import type { ReactNode } from 'react';
import { Stack } from '../primitives/Stack.js';
import { Text } from '../primitives/Text.js';
import { StateIllustration, type StateIllustrationVariant } from './StateIllustration.js';
import styles from './StatusPage.module.css';

export type StatusPageProps = {
  variant: StateIllustrationVariant;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  illustrationSize?: 'sm' | 'md' | 'lg';
  /** Muted sage/feldspar treatment (default on status pages). */
  illustrationTone?: 'soft' | 'default';
  className?: string;
};

/** Centered status shell (errors, 404, empty) with unDraw illustration. */
export function StatusPage({
  variant,
  title,
  description,
  children,
  illustrationSize = 'lg',
  illustrationTone = 'soft',
  className,
}: StatusPageProps) {
  return (
    <div
      data-wp-status-page
      className={className ? `${styles.root} ${className}` : styles.root}
    >
      <Stack gap="md" align="center" className={styles.panel}>
        <div className={styles.illustrationWrap}>
          <StateIllustration variant={variant} size={illustrationSize} tone={illustrationTone} />
        </div>
        <Text component="p" size="md" ff="body" fw={500} className={styles.title} data-wp-status-title>
          {title}
        </Text>
        {description ? (
          typeof description === 'string' ? (
            <Text c="muted" className={styles.description} data-wp-status-description>
              {description}
            </Text>
          ) : (
            <div className={styles.description} data-wp-status-description>
              {description}
            </div>
          )
        ) : null}
        {children ? (
          <div className={styles.actions} data-wp-status-actions>
            {children}
          </div>
        ) : null}
      </Stack>
    </div>
  );
}
